/** Visible gantt result columns for SCRAII AI table view (presentation only). */
export const GANTT_TABLE_COLUMN_CONFIG: { field: string; headerName: string }[] = [
  { field: 'patientid', headerName: 'Patient Id' },
  { field: 'level1', headerName: 'Sp Name' },
  { field: 'level2', headerName: 'Referral Status' },
  { field: 'level3', headerName: 'Status Group' },
  { field: 'level4', headerName: 'Status Sub Group' },
  { field: 'level5', headerName: 'Status Reason Description' },
  { field: 'transactiondate', headerName: 'Status Date' },
  { field: 'transactiontype', headerName: 'Transaction Type' },
  { field: 'statuscodes', headerName: 'Status Reason Code' },
];
